import { Col, Form, Input, InputNumber, Row, Typography } from "antd";

interface Props {
  namePrefix?: Array<string | number>;
}

function buildName(prefix: Array<string | number>, field: string) {
  return [...prefix, field];
}

export function ApartamentoFields({ namePrefix = ["apartamento"] }: Props) {
  return (
    <>
      <Typography.Paragraph type="secondary">
        Preencha os dados do apartamento que você já tiver disponíveis.
      </Typography.Paragraph>

      <Form.Item label="Nome do apartamento" name={buildName(namePrefix, "nome")}>
        <Input placeholder="Ex.: Apartamento 302" />
      </Form.Item>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item label="Capacidade" name={buildName(namePrefix, "capacidade")}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Quartos" name={buildName(namePrefix, "quartos")}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item label="Banheiros" name={buildName(namePrefix, "banheiros")}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Metragem (m²)" name={buildName(namePrefix, "metragem")}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item label="Varanda" name={buildName(namePrefix, "varanda")}>
            <InputNumber min={0} max={1} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item label="Térreo" name={buildName(namePrefix, "terreo")}>
            <InputNumber min={0} max={1} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            label="Estacionamento"
            name={buildName(namePrefix, "estacionamento")}
          >
            <InputNumber min={0} max={1} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
